var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.5,51.2v28a4,4,0,0,0,8,0V51.2a4,4,0,0,0-8,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.96,
    cy: 104.41,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.46,124.82,75,7.91a4,4,0,0,0-6.92,0L.54,124.82a4,4,0,0,0,3.46,6H139a4,4,0,0,0,3.46-6Zm-131.53-2L71.5,17.91l60.57,104.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.16dd5020c9264a62e2550f015b0e30fd.svg";
export { ForwardRef as ReactComponent };